


















































import { StudentService } from "../../biz/remote/StudentService";
import { Vue, Component, Watch } from "vue-property-decorator";
import { TableColumn } from "../../components/organisms/CommonTable.vue";
import {
  dayjs,
  DT_FORMAT_JA,
  D_FORMAT_JA,
  T_FORMAT_JA,
} from "../../../src_server/common/momentExtends";
import { StudentInfoInputDTO } from "../../../src_server/entity/dto/StudentInfoInputDTO";
import { ActorType, ActorTypeNames } from "../../../src_server/biz/ActorType";
import StudnetInfoMaintenance from "./StudnetInfoMaintenance.vue";
import CommonDialog from "../../components/organisms/CommonDialog.vue";
import { routeHelper } from "../../utils/routeHelper";
import { buildingData } from "../../../src_server/entity/master/buildingData";
import { Session } from "../../utils/Session";
import { AuthService } from "../../biz/remote/AuthService";
import { MessageDialog } from "../../utils/MessageDialog";
import SimpleSelect from "../../components/inputs/SimpleSelect.vue";
import { URIs } from "../../../src_server/common/URIs";
import { UserAuthDTO } from "src_server/entity/dto/UserAuthDTO";
import { ErrorHandler } from "../../utils/ErrorHandler";
undefined;

@Component({ components: { StudnetInfoMaintenance, SimpleSelect } })
export default class StudentsListPage extends Vue {
  public viewCount = 10;
  public cols: TableColumn[] = (() => {
    const cols: TableColumn[] = [];
    cols.push({ label: "No", type: "seq" });

    cols.push({
      label: "申込時間",
      type: "renderfunc",
      width: "120px",
      sortitem: "student.insert_dt",
      representedAs: (row: any) => {
        if (!row.student || !row.student.insert_dt) return "";
        return `${dayjs(row.student.insert_dt).format(D_FORMAT_JA)}<br>${dayjs(
          row.student.insert_dt
        ).format(T_FORMAT_JA)}`;
      },
    });
    cols.push({
      label: "年齢",
      type: "renderfunc",
      sortitem: "student.birth_day",
      representedAs: (row: any) => {
        if (!row.student || !row.student.birth_day) return "";
        return `${dayjs().diff(dayjs(row.student.birth_day), "y")}`;
      },
    });

    cols.push({ label: "氏名", name: "student.full_name" });

    cols.push({ label: "ニック<br>ネーム", name: "student.nickname" });
    cols.push({ label: "ログインメール", name: "userAuth.email" });
    cols.push({ label: "LINE名", name: "lineProf.name" });
    cols.push({ label: "LINE<br>メール", name: "lineProf.email" });

    cols.push({ label: "担当先生数", name: "total_teacher_count" });
    cols.push({ label: "授業数", name: "total_lesson_count" });

    cols.push({
      label: "メッセージ履歴",
      btnClass: {
        btn: true,
        "pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-905rem small-xs": true,
      },
      onclick: this.messageLog,
    });

    cols.push({
      label: "パスワード<br>リセット",
      btnClass: {
        btn: true,
        "pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-905rem small-xs": true,
      },
      onclick: this.passwordReset,
    });

    cols.push({
      label: "生徒情報",
      btnClass: {
        btn: true,
        "pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-905rem small-xs": true,
      },
      onclick: this.supportPlan,
    });

    cols.push({
      label: "日報閲覧/<br>キャンセル",
      btnClass: {
        btn: true,
        "pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r  w-705rem  small-xs": true,
      },
      onclick: this.showReport,
    });
    cols.push({
      label: "詳細",
      btnClass: {
        btn: true,
        "pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-505rem  small-xs": true,
      },
      onclick: this.detail,
    });
    cols.push({
      label: "メンテナンスログイン",
      btnClass: {
        btn: true,
        "pl-4 pr-4 clr-wht hvr-bg-red hvr-clr-red rounded-xl btn-neumo btn-neumo-co bsd bc-wht bw-02r w-505rem  small-xs": true,
      },
      onclick: this.forceLogin,
    });

    return cols;
  })();

  private loading = false;
  private rows: StudentInfoInputDTO[] = [];
  private originalRows: StudentInfoInputDTO[] = [];

  get buildings() {
    return buildingData;
  }

  async created() {
    await this.loadData();
  }

  @Watch("filter")
  async loadData() {
    this.loading = true;
    const biz = new StudentService();
    const response = await biz.getAll(Session.getSessionBuildingId());
    this.originalRows = response.data;
    this.rows = this.originalRows.filter((r) => {
      this.loading = false;
      if (!this.filter) return true;
      return r.student.full_name?.match(this.filter);
    });
    this.loading = false;
  }

  private filter = "";

  getCommunicateName(actorType: string) {
    const actorTypeObj = ActorType.getInstanceByName(actorType as ActorTypeNames);
    if (!actorTypeObj) return "";
    return `${actorTypeObj.typeName}`;
  }

  /**
   * 詳細ボタンのイベントハンドラ
   */
  detail(row: any) {
    const dialog = this.$refs["student_detail_dialog"] as StudnetInfoMaintenance;
    dialog.show(row);
  }

  async forceLogin(row: any) {
    const pass = await MessageDialog.prompt(
      "メンテナンスログインします。パスコードを入力してください"
    );
    if (pass === "co01") {
      MessageDialog.info(
        row.userAuth.user_name +
          "にメンテナンスログインします。操作は実際にユーザデータに反映されるため、注意してください。操作終了後は一旦ログアウトしてから管理者ページに戻ってください"
      );
      const user_id = row.userAuth.user_id;
      const biz = new AuthService();
      const result = await biz.forceLogin(user_id, "stu", "co01");

      if (!result || result.hasError) {
        ErrorHandler.atResponseError(result);
        return;
      }
      const dto = result.data;
      Session.set<UserAuthDTO>("USER", dto);

      const redirectPath = `/student-dashboard-page?building=co01`;
      this.$router.push(redirectPath);
    }
  }

  cancel() {
    const dialog = this.$refs["student_detail_dialog"] as CommonDialog;
    dialog.hide();
  }

  deleteStudent(user_id: string) {
    this.rows.splice(
      this.rows.findIndex((p) => p.userAuth.user_id === user_id),
      1
    );
  }

  supportPlan(row: any) {
    const user_id = row.userAuth.user_id;
    routeHelper(this, "SupportPlanPage", { user_id: user_id });
  }

  showReport(row: any) {
    const user_id = row.userAuth.user_id;
    routeHelper(this, "AdminShowLessonsPage", { user_id: user_id });
  }

  async passwordReset(row: any) {
    const isOK = await MessageDialog.confirm(
      `パスワードをリセットして生徒へ通知します。よろしいですか？`
    );
    if (isOK) {
      const user_id = row.userAuth.user_id;
      const authBiz = new AuthService();
      const response = await authBiz.resetInitPassword(
        user_id,
        Session.getSessionBuildingId()
      );
      await MessageDialog.alert(response.data);
    }
  }

  async messageLog(row: any) {
    routeHelper(this, "AdminMessagePage", {
      user_id: row.userAuth.user_id,
      user_type: "stu",
    });
  }

  async csvDl() {
    const url = `${
      URIs.ALL_STUDENT_CSV_DOWNLOAD.path
    }?building_id=${Session.getSessionBuildingId()}&token=${Session.getJwtToken()}`;
    location.href = url;
  }
}
